export const nivo_theme = {
  fontFamily: "Plus Jakarta Sans, sans-serif",
  axis: {
    ticks: {
      text: {
        fontFamily: "Plus Jakarta Sans, sans-serif",
      },
    },
    legend: {
      text: {
        fontFamily: "Plus Jakarta Sans, sans-serif",
        fontWeight: "bold",
      },
    },
  },
  legends: {
    text: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
    },
  },
  labels: {
    text: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
    },
  },
  tooltip: {
    container: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
    },
  },
};
